module.exports = __webpack_public_path__ + "static/moving_noise-adb82c2304f2f3ac0ad0f1ab0074b752.gif";